import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getNotifications, isNonEmptyArray, removeNotification } from '@vista-digital/occ-domain';
import { AnimatePresence, motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { NotificationUI } from '../../subcomponents/notification/subcomponents/ui';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { defaultNotificationListProps, notificationListPropsValidator } from './types/props';
const b = bemClassBuilder('v-notification-list');
/**
 * Ensures the key is unique, even for notifications with the same id.
 * Otherwise if we replace a notification before it's dismissed,
 * it will not remount resulting in no popup animation.
 */
const getNotificationKey = (notification) => {
    var _a;
    return `${notification.id}-${(_a = notification.addedAt) === null || _a === void 0 ? void 0 : _a.toISOString()}`;
};
export const NotificationList = observer(({ events }) => {
    const notifications = getNotifications();
    const handleNotificationClosed = (id) => {
        var _a;
        removeNotification(id);
        (_a = events.onNotificationClosed) === null || _a === void 0 ? void 0 : _a.call(events, id);
    };
    // Render the first two notifications. The others will be off-screen and do not need to be rendered.
    const visibleNotifications = notifications.slice(0, 2);
    return (_jsx(AnimatePresence, { children: isNonEmptyArray(notifications) && (_jsx(motion.ul, { className: b.block(), exit: { opacity: 0, transition: { type: 'tween', duration: 0.3 } }, children: _jsx(AnimatePresence, { children: visibleNotifications.map((notification, index) => {
                    return (_jsx(motion.li, { className: b.element('notification', { top: index === 0, peeking: index === 1 }), initial: { opacity: 0, y: 60 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0 }, layout: "position", transition: { type: 'spring', damping: 15 }, children: _jsx(NotificationUI, Object.assign({}, notification, { autoDismiss: index === 0 ? notification.autoDismiss : false, onCloseButtonClick: () => handleNotificationClosed(notification.id) })) }, getNotificationKey(notification)));
                }) }) })) }));
});
NotificationList.displayName = 'NotificationList';
/**
 * The **Notification List** component renders a list of notifications from the notification store.
 */
export const NotificationListComponent = withComponentWrapper(NotificationList, defaultNotificationListProps, notificationListPropsValidator);
//# sourceMappingURL=notification-list.js.map